export const roundDecimals = (value, decimals): number => {
  return Number(Math.round(Number(value + 'e' + decimals)) + 'e-' + decimals);
};
